import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';

// Pages
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import CreateQuestionPage from './pages/CreateQuestionPage';
import QuestionDetailPage from './pages/QuestionDetailPage';
import NodeDetailPage from './pages/NodeDetailPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import LeaderboardPage from './pages/LeaderboardPage';
import EmbedPage from './pages/EmbedPage';
import { Header } from './components/layout/Header';

// App Router
const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<><Header /><HomePage /></>} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/register" element={<AuthPage />} />
      <Route path="/new" element={<CreateQuestionPage />} />
      <Route path="/q/:questionId" element={<QuestionDetailPage />} />
      <Route path="/embed/:questionId" element={<EmbedPage />} />
      <Route path="/node/:nodeId" element={<NodeDetailPage />} />
      <Route path="/profile/:userId" element={<ProfilePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
    </Routes>
  );
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
